module.exports = __webpack_public_path__ + "fa-regular-400.1f77739ca9ff2188b539.ttf";


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/BEX-VoucherAdmin/src/assets/fonts/webfonts/fa-regular-400.ttf
// module id = ../../../../../src/assets/fonts/webfonts/fa-regular-400.ttf
// module chunks = styles